import React, { Component } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import routes from "../../routes/URL";
import API, { URL_PATH } from "../../services/API";
import Header from "../../components/Header";
import redux from "../../common/Redux";
import {
  Container,
  Typography,
  Box,
  TextField,
  Button,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Switch,
  FormControlLabel,
  IconButton,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import Colors from "../../common/Colors";
import IsolatedStatusModal from "../../components/StatusModal";
import Toast from "../../components/Toast";
import { CustomDatePicker } from "../../components/CustomDatePicker"

class ListMenuScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      suppliers: [],
      rawMaterial: [],
      showOtherSupplier: false,
      toast: {
        open: false,
        message: "",
        severity: "success"
      }
    };
  }

  componentDidMount() {
    const hotel = this.props.hotels.find(h => h.hotel_slug === this.props.match.params.hotelSlug);
    if (!hotel) {
        this.props.history.push(routes.admin.empdashboardloyees.root(this.props.hotels[0]?.hotel_slug || ''));
        return;
    }
    this.getSuppliers();
  }

  getSuppliers = async () => {
    const { status, message, data } = await API(
      this,
      "get",
      URL_PATH.getSuppliers(this.props.selectedHotelId.id)
    );
    if (status == "success") {
      this.setState({ suppliers: data });
    } else {
      // Replace window.Alert with state update for error modal
      this.showToast(message, "error");
    }
  };

  onDelete = async (item) => {
    const { status, message, data } = await API(
      this,
      "post",
      URL_PATH.deleteMenu(item.id)
    );
    if (status == "success") {
      // Replace window.Alert with state update for success modal
      this.showToast(message, "success");
    } else {
      // Replace window.Alert with state update for error modal
      this.showToast(message, "error");
    }
  };

  rawInputChange = (e, index, index2) => {
    const { rawMaterial } = this.state;
    rawMaterial[index][index2] = e.target.value;

    switch (index2) {
      case 1:
      case 3:
        if (rawMaterial[index][1] && rawMaterial[index][3])
          rawMaterial[index][4] =
            parseFloat(rawMaterial[index][1]) *
            parseFloat(rawMaterial[index][3]);
        else rawMaterial[index][4] = "";
        break;
      case 5:
        if (rawMaterial[index][4] && rawMaterial[index][5])
          rawMaterial[index][6] =
            parseFloat(rawMaterial[index][4]) +
            parseFloat(rawMaterial[index][4]) *
            (parseFloat(rawMaterial[index][5]) / 100);
        else rawMaterial[index][6] = "";
    }

    this.setState({
      rawMaterial,
    });
  };

  renderRawInput = (value, index, index2) => {
    const units = [
      "Select Unit",
      "kg",
      "gm",
      "ltr",
      "ml",
      "pcs",
      "dozen",
      "box",
      "bag",
      "bottle",
      "carton",
      "roll",
    ];

    if (index2 == 2) {
      return (
        <Select
          fullWidth
          value={value}
          onChange={(e) => this.rawInputChange(e, index, index2)}
        >
          {units.map((unit, idx) => (
            <MenuItem key={idx} value={unit}>
              {unit}
            </MenuItem>
          ))}
        </Select>
      );
    }

    return (
      <TextField
        fullWidth
        type={index2 == 0 ? "text" : "number"}
        value={value}
        onChange={(e) => this.rawInputChange(e, index, index2)}
        disabled={index2 == 4 || index2 == 6}
        InputLabelProps={{ shrink: true }}
      />
    );
  };

  addRawRow = (n) => {
    const { rawMaterial } = this.state;
    for (let index = 0; index < n; index++) {
      rawMaterial.push(["", "", "", "", "", "", ""]);
    }
    this.setState({
      rawMaterial,
    });
  };

  deleteRawRow = (index) => {
    const { rawMaterial } = this.state;
    rawMaterial.splice(index, 1);
    this.setState({
      rawMaterial,
    });
  };
  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity
      }
    });
  }
  create = async () => {
    const { rawMaterial } = this.state;

    for (let index = 0; index < rawMaterial.length; index++) {
      const element = rawMaterial[index];
      for (let index2 = 0; index2 < element.length; index2++) {
        if (index2 == 4 || index2 == 6) continue; // Skip specific indexes
        const element2 = element[index2];

        if (element2 === "") {
          this.showToast("Please fill all the fields correctly", "error");
          return; // Exit the function if validation fails
        }
      }
    }

    const formData = new FormData(document.getElementById("hotelForm"));
    formData.append("items", JSON.stringify(rawMaterial));
    const { status, message, data } = await API(
      this,
      "post",
      URL_PATH.createInventoryInvoice,
      formData
    );
    if (status == "success") {
      // Replace window.Alert with state update for success modal
      this.showToast(message, "success");
      this.props.history.push(routes.admin.inventory.list);

      this.setState({
        showSuccessModal: true,
        modalMessage: message,
      });
    } else {
      // Replace window.Alert with state update for error modal
      this.showToast(message, "success");
    }
  };

  handleSuccessModalClose = () => {
    // Close success modal and redirect
    this.setState({ showSuccessModal: false });
    this.props.history.push(routes.admin.invoices.list);
  };

  handleErrorModalClose = () => {
    // Close error modal
    this.setState({ showErrorModal: false });
  };

  render() {
    return (
      <Container maxWidth="lg">
        <Box sx={{ my: 4 }}>
          <Header title=" Create Purchase Invoice" />

        </Box>

        <Card sx={{ mb: 3, backgroundColor: "#02111B", backgroundImage: "none", border: "1px solid #FFC857" }}>
          <CardHeader title="Invoice Details" />
          <CardContent>
            <form id="hotelForm" onSubmit={(e) => { e.preventDefault(); this.create(); }}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Supplier"
                    id="supplier"
                    name="inventory_supplier_id"
                    select
                    required
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) => {
                      this.setState({
                        showOtherSupplier: e.target.value == 0,
                      });
                    }}
                  >
                    <MenuItem value="">Select Supplier</MenuItem>
                    {this.state.suppliers.map((item, index) => (
                      <MenuItem key={index} value={item.id}>
                        {item.supplier_name}
                      </MenuItem>
                    ))}
                    <MenuItem value="0">New</MenuItem>
                  </TextField>
                </Grid>
                {this.state.showOtherSupplier && (
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Other Supplier"
                      id="other_supplier"
                      name="other_supplier"
                      required
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                )}
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Invoice Number"
                    id="invoice_number"
                    name="invoice_number"
                    required
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <CustomDatePicker
                    fullWidth
                    label="Invoice Date"
                    placeholder="dd-mm-yyyy"
                    id="invoice_date"
                    name="invoice_date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Invoice Amount"
                    id="invoice_amount"
                    type={"number"}

                    name="invoice_amount"
                    required
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Delivery Charge"
                    id="delivery_charge"
                    name="delivery_charge"
                    required
                    InputLabelProps={{ shrink: true }}
                    type={"number"}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="GST Amount"
                    id="gst_amount"
                    name="gst"
                    type={"number"}

                    required
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Upload Invoice File"
                    id="invoice_file"
                    name="invoice_file"
                    type="file"
                    required
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Payment Status"
                    id="payment_status"
                    name="payment_status"
                    select
                    required
                    InputLabelProps={{ shrink: true }}
                  >
                    <MenuItem value="1">Paid</MenuItem>
                    <MenuItem value="2">Unpaid</MenuItem>
                  </TextField>
                </Grid>
              </Grid>
            </form>
          </CardContent>
        </Card>

        <Card sx={{ mb: 3, backgroundColor: "#02111B", backgroundImage: "none", border: "1px solid #FFC857" }}>
          <CardHeader title="Raw Material Details" />
          <CardContent>
            <TableContainer component={Paper}>
              <Table sx={{ backgroundColor: "#02111B", backgroundImage: "none", }} >
                <TableHead>
                  <TableRow>
                    {[
                      "Name",
                      "Quantity",
                      "Unit",
                      "Price",
                      "Total",
                      "GST(%)",
                      "Total with GST",
                      "Action",
                    ].map((item, index) => (
                      <TableCell key={index}>{item}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.rawMaterial.map((item, index) => (
                    <TableRow key={index}>
                      {item.map((value, index2) => (
                        <TableCell key={index2}>
                          {this.renderRawInput(value, index, index2)}
                        </TableCell>
                      ))}
                      <TableCell>
                        <IconButton onClick={() => this.deleteRawRow(index)}>
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between" }}>
              <Box>
                <Button
                  variant="contained"
                  onClick={() => this.addRawRow(1)}
                  sx={{ mr: 1, backgroundColor: "#02111B", color: "white", border: "1px solid #FFC857", fontWeight: 700, "&:hover": { backgroundColor: "#02111B" } }}

                >
                  + Add Row
                </Button>
                <Button
                  variant="contained"
                  onClick={() => this.addRawRow(5)}
                  sx={{ mr: 1, backgroundColor: "#02111B", color: "white", border: "1px solid #FFC857", fontWeight: 700, "&:hover": { backgroundColor: "#02111B" } }}
                >
                  + Add 5 Rows
                </Button>
                <Button
                  variant="contained"
                  onClick={() => this.addRawRow(10)}
                  sx={{ mr: 1, backgroundColor: "#02111B", color: "white", border: "1px solid #FFC857", fontWeight: 700, "&:hover": { backgroundColor: "#02111B" } }}

                >
                  + Add 10 Rows
                </Button>
              </Box>
              <Button
                variant="contained"
                type="submit"
                onClick={() => this.create()}
                sx={{ mr: 1, backgroundColor: "#FFC857", fontWeight: 700, "&:hover": { backgroundColor: "#E6B74D" } }}

              >
                Save Changes
              </Button>
            </Box>
          </CardContent>
        </Card>

        <Toast
          open={this.state.toast.open}
          message={this.state.toast.message}
          severity={this.state.toast.severity}
          handleClose={this.handleCloseToast}
        />
      </Container>
    );
  }
}

export default redux(ListMenuScreen); 